// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  ActionsDescribeActionData,
  ActionsDescribeActionErrors,
  ActionsDescribeActionResponses,
  ActionsListActionsData,
  ActionsListActionsErrors,
  ActionsListActionsResponses,
  AgentsDefineAgentOutcomeData,
  AgentsDefineAgentOutcomeErrors,
  AgentsDefineAgentOutcomeResponses,
  AgentsGetCanvasAgentChatData,
  AgentsGetCanvasAgentChatErrors,
  AgentsGetCanvasAgentChatResponses,
  AgentsInterruptAgentChatData,
  AgentsInterruptAgentChatErrors,
  AgentsInterruptAgentChatResponses,
  AgentsListAgentChatMessagesData,
  AgentsListAgentChatMessagesErrors,
  AgentsListAgentChatMessagesResponses,
  AgentsSendAgentChatMessageData,
  AgentsSendAgentChatMessageErrors,
  AgentsSendAgentChatMessageResponses,
  CanvasesCancelExecutionData,
  CanvasesCancelExecutionErrors,
  CanvasesCancelExecutionResponses,
  CanvasesCommitCanvasRepositoryFilesData,
  CanvasesCommitCanvasRepositoryFilesErrors,
  CanvasesCommitCanvasRepositoryFilesResponses,
  CanvasesCommitCanvasStagingData,
  CanvasesCommitCanvasStagingErrors,
  CanvasesCommitCanvasStagingResponses,
  CanvasesCreateCanvasData,
  CanvasesCreateCanvasErrors,
  CanvasesCreateCanvasMemoryNamespaceData,
  CanvasesCreateCanvasMemoryNamespaceErrors,
  CanvasesCreateCanvasMemoryNamespaceResponses,
  CanvasesCreateCanvasResponses,
  CanvasesCreateCanvasVersionData,
  CanvasesCreateCanvasVersionErrors,
  CanvasesCreateCanvasVersionResponses,
  CanvasesDeleteCanvasData,
  CanvasesDeleteCanvasErrors,
  CanvasesDeleteCanvasMemoryData,
  CanvasesDeleteCanvasMemoryErrors,
  CanvasesDeleteCanvasMemoryResponses,
  CanvasesDeleteCanvasResponses,
  CanvasesDeleteCanvasVersionData,
  CanvasesDeleteCanvasVersionErrors,
  CanvasesDeleteCanvasVersionResponses,
  CanvasesDeleteNodeQueueItemData,
  CanvasesDeleteNodeQueueItemErrors,
  CanvasesDeleteNodeQueueItemResponses,
  CanvasesDescribeCanvasData,
  CanvasesDescribeCanvasErrors,
  CanvasesDescribeCanvasResponses,
  CanvasesDescribeCanvasVersionData,
  CanvasesDescribeCanvasVersionErrors,
  CanvasesDescribeCanvasVersionResponses,
  CanvasesDescribeRunData,
  CanvasesDescribeRunErrors,
  CanvasesDescribeRunResponses,
  CanvasesDiscardCanvasStagingData,
  CanvasesDiscardCanvasStagingErrors,
  CanvasesDiscardCanvasStagingResponses,
  CanvasesGetCanvasRepositoryData,
  CanvasesGetCanvasRepositoryErrors,
  CanvasesGetCanvasRepositoryResponses,
  CanvasesInvokeNodeExecutionHookData,
  CanvasesInvokeNodeExecutionHookErrors,
  CanvasesInvokeNodeExecutionHookResponses,
  CanvasesInvokeNodeTriggerHookData,
  CanvasesInvokeNodeTriggerHookErrors,
  CanvasesInvokeNodeTriggerHookResponses,
  CanvasesListCanvasesData,
  CanvasesListCanvasesErrors,
  CanvasesListCanvasesResponses,
  CanvasesListCanvasMemoriesData,
  CanvasesListCanvasMemoriesErrors,
  CanvasesListCanvasMemoriesResponses,
  CanvasesListCanvasRepositoryFilesData,
  CanvasesListCanvasRepositoryFilesErrors,
  CanvasesListCanvasRepositoryFilesResponses,
  CanvasesListCanvasVersionsData,
  CanvasesListCanvasVersionsErrors,
  CanvasesListCanvasVersionsResponses,
  CanvasesListEventExecutionsData,
  CanvasesListEventExecutionsErrors,
  CanvasesListEventExecutionsResponses,
  CanvasesListNodeEventsData,
  CanvasesListNodeEventsErrors,
  CanvasesListNodeEventsResponses,
  CanvasesListNodeExecutionsData,
  CanvasesListNodeExecutionsErrors,
  CanvasesListNodeExecutionsResponses,
  CanvasesListNodeQueueItemsData,
  CanvasesListNodeQueueItemsErrors,
  CanvasesListNodeQueueItemsResponses,
  CanvasesListRunsData,
  CanvasesListRunsErrors,
  CanvasesListRunsResponses,
  CanvasesPublishCanvasVersionData,
  CanvasesPublishCanvasVersionErrors,
  CanvasesPublishCanvasVersionResponses,
  CanvasesReemitTriggerEventData,
  CanvasesReemitTriggerEventErrors,
  CanvasesReemitTriggerEventResponses,
  CanvasesResolveExecutionErrorsData,
  CanvasesResolveExecutionErrorsErrors,
  CanvasesResolveExecutionErrorsResponses,
  CanvasesStageCanvasRepositoryFileData,
  CanvasesStageCanvasRepositoryFileErrors,
  CanvasesStageCanvasRepositoryFileResponses,
  CanvasesUpdateCanvasData,
  CanvasesUpdateCanvasErrors,
  CanvasesUpdateCanvasMemoryNamespaceData,
  CanvasesUpdateCanvasMemoryNamespaceErrors,
  CanvasesUpdateCanvasMemoryNamespaceResponses,
  CanvasesUpdateCanvasResponses,
  CanvasFoldersCreateCanvasFolderData,
  CanvasFoldersCreateCanvasFolderErrors,
  CanvasFoldersCreateCanvasFolderResponses,
  CanvasFoldersDeleteCanvasFolderData,
  CanvasFoldersDeleteCanvasFolderErrors,
  CanvasFoldersDeleteCanvasFolderResponses,
  CanvasFoldersListCanvasFoldersData,
  CanvasFoldersListCanvasFoldersErrors,
  CanvasFoldersListCanvasFoldersResponses,
  CanvasFoldersUpdateCanvasFolderData,
  CanvasFoldersUpdateCanvasFolderErrors,
  CanvasFoldersUpdateCanvasFolderPositionData,
  CanvasFoldersUpdateCanvasFolderPositionErrors,
  CanvasFoldersUpdateCanvasFolderPositionResponses,
  CanvasFoldersUpdateCanvasFolderResponses,
  GroupsAddUserToGroupData,
  GroupsAddUserToGroupErrors,
  GroupsAddUserToGroupResponses,
  GroupsCreateGroupData,
  GroupsCreateGroupErrors,
  GroupsCreateGroupResponses,
  GroupsDeleteGroupData,
  GroupsDeleteGroupErrors,
  GroupsDeleteGroupResponses,
  GroupsDescribeGroupData,
  GroupsDescribeGroupErrors,
  GroupsDescribeGroupResponses,
  GroupsListGroupsData,
  GroupsListGroupsErrors,
  GroupsListGroupsResponses,
  GroupsListGroupUsersData,
  GroupsListGroupUsersErrors,
  GroupsListGroupUsersResponses,
  GroupsRemoveUserFromGroupData,
  GroupsRemoveUserFromGroupErrors,
  GroupsRemoveUserFromGroupResponses,
  GroupsUpdateGroupData,
  GroupsUpdateGroupErrors,
  GroupsUpdateGroupResponses,
  IntegrationsListIntegrationsData,
  IntegrationsListIntegrationsErrors,
  IntegrationsListIntegrationsResponses,
  MeMeData,
  MeMeErrors,
  MeMeResponses,
  MeRegenerateTokenData,
  MeRegenerateTokenErrors,
  MeRegenerateTokenResponses,
  OrganizationsAcceptInviteLinkData,
  OrganizationsAcceptInviteLinkErrors,
  OrganizationsAcceptInviteLinkResponses,
  OrganizationsCreateIntegrationData,
  OrganizationsCreateIntegrationErrors,
  OrganizationsCreateIntegrationResponses,
  OrganizationsDeleteIntegrationData,
  OrganizationsDeleteIntegrationErrors,
  OrganizationsDeleteIntegrationResponses,
  OrganizationsDeleteOrganizationData,
  OrganizationsDeleteOrganizationErrors,
  OrganizationsDeleteOrganizationResponses,
  OrganizationsDescribeIntegrationData,
  OrganizationsDescribeIntegrationErrors,
  OrganizationsDescribeIntegrationResponses,
  OrganizationsDescribeOrganizationData,
  OrganizationsDescribeOrganizationErrors,
  OrganizationsDescribeOrganizationResponses,
  OrganizationsDescribeUsageData,
  OrganizationsDescribeUsageErrors,
  OrganizationsDescribeUsageResponses,
  OrganizationsGetInviteLinkData,
  OrganizationsGetInviteLinkErrors,
  OrganizationsGetInviteLinkResponses,
  OrganizationsListIntegrationResourcesData,
  OrganizationsListIntegrationResourcesErrors,
  OrganizationsListIntegrationResourcesResponses,
  OrganizationsListIntegrationsData,
  OrganizationsListIntegrationsErrors,
  OrganizationsListIntegrationsResponses,
  OrganizationsNextIntegrationSetupStepData,
  OrganizationsNextIntegrationSetupStepErrors,
  OrganizationsNextIntegrationSetupStepResponses,
  OrganizationsPreviousIntegrationSetupStepData,
  OrganizationsPreviousIntegrationSetupStepErrors,
  OrganizationsPreviousIntegrationSetupStepResponses,
  OrganizationsRemoveUserData,
  OrganizationsRemoveUserErrors,
  OrganizationsRemoveUserResponses,
  OrganizationsResetInviteLinkData,
  OrganizationsResetInviteLinkErrors,
  OrganizationsResetInviteLinkResponses,
  OrganizationsUpdateIntegrationCapabilitiesData,
  OrganizationsUpdateIntegrationCapabilitiesErrors,
  OrganizationsUpdateIntegrationCapabilitiesResponses,
  OrganizationsUpdateIntegrationData,
  OrganizationsUpdateIntegrationErrors,
  OrganizationsUpdateIntegrationPropertyData,
  OrganizationsUpdateIntegrationPropertyErrors,
  OrganizationsUpdateIntegrationPropertyResponses,
  OrganizationsUpdateIntegrationResponses,
  OrganizationsUpdateIntegrationSecretData,
  OrganizationsUpdateIntegrationSecretErrors,
  OrganizationsUpdateIntegrationSecretResponses,
  OrganizationsUpdateInviteLinkData,
  OrganizationsUpdateInviteLinkErrors,
  OrganizationsUpdateInviteLinkResponses,
  OrganizationsUpdateOrganizationData,
  OrganizationsUpdateOrganizationErrors,
  OrganizationsUpdateOrganizationResponses,
  RolesAssignRoleData,
  RolesAssignRoleErrors,
  RolesAssignRoleResponses,
  RolesCreateRoleData,
  RolesCreateRoleErrors,
  RolesCreateRoleResponses,
  RolesDeleteRoleData,
  RolesDeleteRoleErrors,
  RolesDeleteRoleResponses,
  RolesDescribeRoleData,
  RolesDescribeRoleErrors,
  RolesDescribeRoleResponses,
  RolesListRolesData,
  RolesListRolesErrors,
  RolesListRolesResponses,
  RolesUpdateRoleData,
  RolesUpdateRoleErrors,
  RolesUpdateRoleResponses,
  SecretsCreateSecretData,
  SecretsCreateSecretErrors,
  SecretsCreateSecretResponses,
  SecretsDeleteSecretData,
  SecretsDeleteSecretErrors,
  SecretsDeleteSecretKeyData,
  SecretsDeleteSecretKeyErrors,
  SecretsDeleteSecretKeyResponses,
  SecretsDeleteSecretResponses,
  SecretsDescribeSecretData,
  SecretsDescribeSecretErrors,
  SecretsDescribeSecretResponses,
  SecretsListSecretsData,
  SecretsListSecretsErrors,
  SecretsListSecretsResponses,
  SecretsSetSecretKeyData,
  SecretsSetSecretKeyErrors,
  SecretsSetSecretKeyResponses,
  SecretsUpdateSecretData,
  SecretsUpdateSecretErrors,
  SecretsUpdateSecretNameData,
  SecretsUpdateSecretNameErrors,
  SecretsUpdateSecretNameResponses,
  SecretsUpdateSecretResponses,
  ServiceAccountsCreateServiceAccountData,
  ServiceAccountsCreateServiceAccountErrors,
  ServiceAccountsCreateServiceAccountResponses,
  ServiceAccountsDeleteServiceAccountData,
  ServiceAccountsDeleteServiceAccountErrors,
  ServiceAccountsDeleteServiceAccountResponses,
  ServiceAccountsDescribeServiceAccountData,
  ServiceAccountsDescribeServiceAccountErrors,
  ServiceAccountsDescribeServiceAccountResponses,
  ServiceAccountsListServiceAccountsData,
  ServiceAccountsListServiceAccountsErrors,
  ServiceAccountsListServiceAccountsResponses,
  ServiceAccountsRegenerateServiceAccountTokenData,
  ServiceAccountsRegenerateServiceAccountTokenErrors,
  ServiceAccountsRegenerateServiceAccountTokenResponses,
  ServiceAccountsUpdateServiceAccountData,
  ServiceAccountsUpdateServiceAccountErrors,
  ServiceAccountsUpdateServiceAccountResponses,
  TriggersDescribeTriggerData,
  TriggersDescribeTriggerErrors,
  TriggersDescribeTriggerResponses,
  TriggersListTriggersData,
  TriggersListTriggersErrors,
  TriggersListTriggersResponses,
  UsersListUsersData,
  UsersListUsersErrors,
  UsersListUsersResponses,
  WidgetsDescribeWidgetData,
  WidgetsDescribeWidgetErrors,
  WidgetsDescribeWidgetResponses,
  WidgetsListWidgetsData,
  WidgetsListWidgetsErrors,
  WidgetsListWidgetsResponses,
} from "./types.gen";

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * List actions
 *
 * Returns a list of all actions
 */
export const actionsListActions = <ThrowOnError extends boolean = true>(
  options?: Options<ActionsListActionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ActionsListActionsResponses, ActionsListActionsErrors, ThrowOnError>({
    url: "/api/v1/actions",
    ...options,
  });

/**
 * Describe action
 *
 * Returns an action by its name
 */
export const actionsDescribeAction = <ThrowOnError extends boolean = true>(
  options: Options<ActionsDescribeActionData, ThrowOnError>,
) =>
  (options.client ?? client).get<ActionsDescribeActionResponses, ActionsDescribeActionErrors, ThrowOnError>({
    url: "/api/v1/actions/{name}",
    ...options,
  });

/**
 * Get or create the user's chat for a canvas
 *
 * Returns the user's single chat session for the given canvas, provisioning it on first call. The session is permanent.
 */
export const agentsGetCanvasAgentChat = <ThrowOnError extends boolean = true>(
  options: Options<AgentsGetCanvasAgentChatData, ThrowOnError>,
) =>
  (options.client ?? client).get<AgentsGetCanvasAgentChatResponses, AgentsGetCanvasAgentChatErrors, ThrowOnError>({
    url: "/api/v1/agents/canvases/{canvasId}/chat",
    ...options,
  });

/**
 * Interrupt agent execution
 *
 * Sends a user.interrupt event to stop the agent mid-execution.
 */
export const agentsInterruptAgentChat = <ThrowOnError extends boolean = true>(
  options: Options<AgentsInterruptAgentChatData, ThrowOnError>,
) =>
  (options.client ?? client).post<AgentsInterruptAgentChatResponses, AgentsInterruptAgentChatErrors, ThrowOnError>({
    url: "/api/v1/agents/chats/{chatId}/interrupt",
    ...options,
  });

/**
 * List messages older than a cursor
 *
 * Returns up to `limit` messages strictly older than `before_id`, oldest-first. Omit `before_id` to fetch the most recent page.
 */
export const agentsListAgentChatMessages = <ThrowOnError extends boolean = true>(
  options: Options<AgentsListAgentChatMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<AgentsListAgentChatMessagesResponses, AgentsListAgentChatMessagesErrors, ThrowOnError>(
    { url: "/api/v1/agents/chats/{chatId}/messages", ...options },
  );

/**
 * Send a user message to the chat
 *
 * Persists the user message, forwards it to the upstream provider, and triggers an async stream of assistant events broadcast over the chat's websocket topic.
 */
export const agentsSendAgentChatMessage = <ThrowOnError extends boolean = true>(
  options: Options<AgentsSendAgentChatMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<AgentsSendAgentChatMessageResponses, AgentsSendAgentChatMessageErrors, ThrowOnError>({
    url: "/api/v1/agents/chats/{chatId}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Define outcome for agent
 *
 * Sends a user.define_outcome event with a rubric. The agent works toward the rubric with a grader evaluating each iteration.
 */
export const agentsDefineAgentOutcome = <ThrowOnError extends boolean = true>(
  options: Options<AgentsDefineAgentOutcomeData, ThrowOnError>,
) =>
  (options.client ?? client).post<AgentsDefineAgentOutcomeResponses, AgentsDefineAgentOutcomeErrors, ThrowOnError>({
    url: "/api/v1/agents/chats/{chatId}/outcome",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas folders
 *
 * Returns all canvas folders for an organization
 */
export const canvasFoldersListCanvasFolders = <ThrowOnError extends boolean = true>(
  options?: Options<CanvasFoldersListCanvasFoldersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    CanvasFoldersListCanvasFoldersResponses,
    CanvasFoldersListCanvasFoldersErrors,
    ThrowOnError
  >({ url: "/api/v1/canvas-folders", ...options });

/**
 * Create canvas folder
 *
 * Creates a canvas folder
 */
export const canvasFoldersCreateCanvasFolder = <ThrowOnError extends boolean = true>(
  options: Options<CanvasFoldersCreateCanvasFolderData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasFoldersCreateCanvasFolderResponses,
    CanvasFoldersCreateCanvasFolderErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvas-folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete canvas folder
 *
 * Deletes a canvas folder without deleting its canvases
 */
export const canvasFoldersDeleteCanvasFolder = <ThrowOnError extends boolean = true>(
  options: Options<CanvasFoldersDeleteCanvasFolderData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    CanvasFoldersDeleteCanvasFolderResponses,
    CanvasFoldersDeleteCanvasFolderErrors,
    ThrowOnError
  >({ url: "/api/v1/canvas-folders/{id}", ...options });

/**
 * Update canvas folder
 *
 * Updates a canvas folder
 */
export const canvasFoldersUpdateCanvasFolder = <ThrowOnError extends boolean = true>(
  options: Options<CanvasFoldersUpdateCanvasFolderData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    CanvasFoldersUpdateCanvasFolderResponses,
    CanvasFoldersUpdateCanvasFolderErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvas-folders/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update canvas folder position
 *
 * Moves a canvas folder up or down
 */
export const canvasFoldersUpdateCanvasFolderPosition = <ThrowOnError extends boolean = true>(
  options: Options<CanvasFoldersUpdateCanvasFolderPositionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CanvasFoldersUpdateCanvasFolderPositionResponses,
    CanvasFoldersUpdateCanvasFolderPositionErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvas-folders/{id}/position",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvases
 *
 * Returns a list of all canvases
 */
export const canvasesListCanvases = <ThrowOnError extends boolean = true>(
  options?: Options<CanvasesListCanvasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<CanvasesListCanvasesResponses, CanvasesListCanvasesErrors, ThrowOnError>({
    url: "/api/v1/canvases",
    ...options,
  });

/**
 * Create canvas
 *
 * Creates a new canvas
 */
export const canvasesCreateCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCreateCanvasData, ThrowOnError>,
) =>
  (options.client ?? client).post<CanvasesCreateCanvasResponses, CanvasesCreateCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List event executions
 *
 * Returns a list of all node executions triggered by a root event
 */
export const canvasesListEventExecutions = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListEventExecutionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListEventExecutionsResponses, CanvasesListEventExecutionsErrors, ThrowOnError>(
    { url: "/api/v1/canvases/{canvasId}/events/{eventId}/executions", ...options },
  );

/**
 * Resolve execution errors
 *
 * Marks canvas node execution errors as resolved
 */
export const canvasesResolveExecutionErrors = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesResolveExecutionErrorsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CanvasesResolveExecutionErrorsResponses,
    CanvasesResolveExecutionErrorsErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/executions/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel execution
 *
 * Cancels a running canvas node execution
 */
export const canvasesCancelExecution = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCancelExecutionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<CanvasesCancelExecutionResponses, CanvasesCancelExecutionErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/executions/{executionId}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Invoke execution hook
 *
 * Invokes a custom hook on a canvas node execution
 */
export const canvasesInvokeNodeExecutionHook = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesInvokeNodeExecutionHookData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesInvokeNodeExecutionHookResponses,
    CanvasesInvokeNodeExecutionHookErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/executions/{executionId}/hooks/{hookName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas memories
 *
 * Returns append-only memory records for a canvas
 */
export const canvasesListCanvasMemories = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListCanvasMemoriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListCanvasMemoriesResponses, CanvasesListCanvasMemoriesErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/memory",
    ...options,
  });

/**
 * Create manual canvas memory namespace
 *
 * Creates a manually-managed memory namespace with the provided entries. Rejected if the namespace already has any entries.
 */
export const canvasesCreateCanvasMemoryNamespace = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCreateCanvasMemoryNamespaceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesCreateCanvasMemoryNamespaceResponses,
    CanvasesCreateCanvasMemoryNamespaceErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/memory/namespaces",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update manual canvas memory namespace
 *
 * Replaces the entries of a manually-managed memory namespace, optionally renaming it. Rejected if the namespace is node-managed.
 */
export const canvasesUpdateCanvasMemoryNamespace = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesUpdateCanvasMemoryNamespaceData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    CanvasesUpdateCanvasMemoryNamespaceResponses,
    CanvasesUpdateCanvasMemoryNamespaceErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/memory/namespaces/{namespace}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete canvas memory entry
 *
 * Deletes one memory record by ID from a canvas
 */
export const canvasesDeleteCanvasMemory = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteCanvasMemoryData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    CanvasesDeleteCanvasMemoryResponses,
    CanvasesDeleteCanvasMemoryErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/memory/{memoryId}", ...options });

/**
 * List node events
 *
 * Returns a list of events for a specific canvas node
 */
export const canvasesListNodeEvents = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListNodeEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListNodeEventsResponses, CanvasesListNodeEventsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/events",
    ...options,
  });

/**
 * List node executions
 *
 * Returns a list of executions for a specific canvas node
 */
export const canvasesListNodeExecutions = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListNodeExecutionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListNodeExecutionsResponses, CanvasesListNodeExecutionsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/executions",
    ...options,
  });

/**
 * List items in a node's queue
 *
 * Returns a list of items in a node's queue
 */
export const canvasesListNodeQueueItems = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListNodeQueueItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListNodeQueueItemsResponses, CanvasesListNodeQueueItemsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/queue",
    ...options,
  });

/**
 * Delete item from a node's queue
 *
 * Deletes a specific item in a node's queue
 */
export const canvasesDeleteNodeQueueItem = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteNodeQueueItemData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    CanvasesDeleteNodeQueueItemResponses,
    CanvasesDeleteNodeQueueItemErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/nodes/{nodeId}/queue/{itemId}", ...options });

/**
 * Get canvas repository
 *
 * Returns information about the canvas git repository
 */
export const canvasesGetCanvasRepository = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesGetCanvasRepositoryData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesGetCanvasRepositoryResponses, CanvasesGetCanvasRepositoryErrors, ThrowOnError>(
    { url: "/api/v1/canvases/{canvasId}/repository", ...options },
  );

/**
 * Commit canvas repository files
 *
 * Commits file additions, updates, and deletions directly to a canvas, discarding any existing draft staging for the target version in the same transaction
 */
export const canvasesCommitCanvasRepositoryFiles = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCommitCanvasRepositoryFilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesCommitCanvasRepositoryFilesResponses,
    CanvasesCommitCanvasRepositoryFilesErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/repository/commits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas repository files
 *
 * Lists files in the git repository attached to a canvas
 */
export const canvasesListCanvasRepositoryFiles = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListCanvasRepositoryFilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    CanvasesListCanvasRepositoryFilesResponses,
    CanvasesListCanvasRepositoryFilesErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/repository/files", ...options });

/**
 * List canvas runs
 *
 * Returns a list of runs for a canvas
 */
export const canvasesListRuns = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListRunsData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListRunsResponses, CanvasesListRunsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/runs",
    ...options,
  });

/**
 * Describe a run
 *
 * Returns a description of a run
 */
export const canvasesDescribeRun = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDescribeRunData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesDescribeRunResponses, CanvasesDescribeRunErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/runs/{runId}",
    ...options,
  });

/**
 * Re-emit trigger event
 *
 * Re-emits an existing root event from a trigger node
 */
export const canvasesReemitTriggerEvent = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesReemitTriggerEventData, ThrowOnError>,
) =>
  (options.client ?? client).post<CanvasesReemitTriggerEventResponses, CanvasesReemitTriggerEventErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/triggers/{nodeId}/events/{eventId}/reemit",
    ...options,
  });

/**
 * Invoke trigger hook
 *
 * Invokes a custom hook on a canvas node trigger
 */
export const canvasesInvokeNodeTriggerHook = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesInvokeNodeTriggerHookData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesInvokeNodeTriggerHookResponses,
    CanvasesInvokeNodeTriggerHookErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/triggers/{nodeId}/hooks/{hookName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List canvas versions
 *
 * Lists all versions for a canvas
 */
export const canvasesListCanvasVersions = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesListCanvasVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesListCanvasVersionsResponses, CanvasesListCanvasVersionsErrors, ThrowOnError>({
    url: "/api/v1/canvases/{canvasId}/versions",
    ...options,
  });

/**
 * Create canvas version
 *
 * Creates a new draft canvas version from the live canvas
 */
export const canvasesCreateCanvasVersion = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCreateCanvasVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesCreateCanvasVersionResponses,
    CanvasesCreateCanvasVersionErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Discard draft canvas version
 *
 * Discards a user-owned draft canvas version
 */
export const canvasesDeleteCanvasVersion = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteCanvasVersionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    CanvasesDeleteCanvasVersionResponses,
    CanvasesDeleteCanvasVersionErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/versions/{versionId}", ...options });

/**
 * Describe canvas version
 *
 * Returns one canvas version by ID
 */
export const canvasesDescribeCanvasVersion = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDescribeCanvasVersionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    CanvasesDescribeCanvasVersionResponses,
    CanvasesDescribeCanvasVersionErrors,
    ThrowOnError
  >({ url: "/api/v1/canvases/{canvasId}/versions/{versionId}", ...options });

/**
 * Publish draft canvas version
 *
 * Publishes a user-owned draft canvas version directly to live
 */
export const canvasesPublishCanvasVersion = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesPublishCanvasVersionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    CanvasesPublishCanvasVersionResponses,
    CanvasesPublishCanvasVersionErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/versions/{versionId}/publish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Commit canvas staging
 *
 * Parses staged canvas.yaml and console.yaml into the draft version and clears staging
 */
export const canvasesCommitCanvasStaging = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesCommitCanvasStagingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesCommitCanvasStagingResponses,
    CanvasesCommitCanvasStagingErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/versions/{versionId}/staging/commit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Discard canvas staging
 *
 * Discards staged spec changes for a draft version; omit paths to discard all staged files
 */
export const canvasesDiscardCanvasStaging = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDiscardCanvasStagingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesDiscardCanvasStagingResponses,
    CanvasesDiscardCanvasStagingErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/versions/{versionId}/staging/discard",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stage canvas repository file
 *
 * Writes canvas.yaml/console.yaml edits to a draft version's staging layer without touching the version row
 */
export const canvasesStageCanvasRepositoryFile = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesStageCanvasRepositoryFileData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CanvasesStageCanvasRepositoryFileResponses,
    CanvasesStageCanvasRepositoryFileErrors,
    ThrowOnError
  >({
    url: "/api/v1/canvases/{canvasId}/versions/{versionId}/staging/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete canvas
 *
 * Deletes an existing canvas
 */
export const canvasesDeleteCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDeleteCanvasData, ThrowOnError>,
) =>
  (options.client ?? client).delete<CanvasesDeleteCanvasResponses, CanvasesDeleteCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases/{id}",
    ...options,
  });

/**
 * Describe canvas
 *
 * Returns a canvas by ID
 */
export const canvasesDescribeCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesDescribeCanvasData, ThrowOnError>,
) =>
  (options.client ?? client).get<CanvasesDescribeCanvasResponses, CanvasesDescribeCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases/{id}",
    ...options,
  });

/**
 * Update canvas
 *
 * Updates canvas metadata
 */
export const canvasesUpdateCanvas = <ThrowOnError extends boolean = true>(
  options: Options<CanvasesUpdateCanvasData, ThrowOnError>,
) =>
  (options.client ?? client).put<CanvasesUpdateCanvasResponses, CanvasesUpdateCanvasErrors, ThrowOnError>({
    url: "/api/v1/canvases/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List groups
 *
 * Returns a list of groups within a domain
 */
export const groupsListGroups = <ThrowOnError extends boolean = true>(
  options?: Options<GroupsListGroupsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GroupsListGroupsResponses, GroupsListGroupsErrors, ThrowOnError>({
    url: "/api/v1/groups",
    ...options,
  });

/**
 * Create group
 *
 * Creates a new group within a domain with a specific role
 */
export const groupsCreateGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsCreateGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<GroupsCreateGroupResponses, GroupsCreateGroupErrors, ThrowOnError>({
    url: "/api/v1/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete group
 *
 * Deletes an existing group within a domain
 */
export const groupsDeleteGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsDeleteGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<GroupsDeleteGroupResponses, GroupsDeleteGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}",
    ...options,
  });

/**
 * Get group
 *
 * Returns details of a specific group within a domain
 */
export const groupsDescribeGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsDescribeGroupData, ThrowOnError>,
) =>
  (options.client ?? client).get<GroupsDescribeGroupResponses, GroupsDescribeGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}",
    ...options,
  });

/**
 * Update group
 *
 * Updates an existing group within a domain
 */
export const groupsUpdateGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsUpdateGroupData, ThrowOnError>,
) =>
  (options.client ?? client).put<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get group users
 *
 * Returns users that belong to a specific group within a domain
 */
export const groupsListGroupUsers = <ThrowOnError extends boolean = true>(
  options: Options<GroupsListGroupUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<GroupsListGroupUsersResponses, GroupsListGroupUsersErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}/users",
    ...options,
  });

/**
 * Add user to group
 *
 * Adds a user to a group within a domain
 */
export const groupsAddUserToGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddUserToGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<GroupsAddUserToGroupResponses, GroupsAddUserToGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove user from group
 *
 * Removes a user from a group within a domain
 */
export const groupsRemoveUserFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveUserFromGroupData, ThrowOnError>,
) =>
  (options.client ?? client).patch<GroupsRemoveUserFromGroupResponses, GroupsRemoveUserFromGroupErrors, ThrowOnError>({
    url: "/api/v1/groups/{groupName}/users/remove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List available integrations
 *
 * List available integrations
 */
export const integrationsListIntegrations = <ThrowOnError extends boolean = true>(
  options?: Options<IntegrationsListIntegrationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    IntegrationsListIntegrationsResponses,
    IntegrationsListIntegrationsErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations", ...options });

/**
 * Accept an invite link
 *
 * Accepts an organization invite link for the authenticated account
 */
export const organizationsAcceptInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsAcceptInviteLinkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    OrganizationsAcceptInviteLinkResponses,
    OrganizationsAcceptInviteLinkErrors,
    ThrowOnError
  >({ url: "/api/v1/invite-links/{token}/accept", ...options });

/**
 * Get current user
 *
 * Returns the currently authenticated user
 */
export const meMe = <ThrowOnError extends boolean = true>(options?: Options<MeMeData, ThrowOnError>) =>
  (options?.client ?? client).get<MeMeResponses, MeMeErrors, ThrowOnError>({ url: "/api/v1/me", ...options });

/**
 * Regenerate API token
 *
 * Regenerates the currently authencated user's API token
 */
export const meRegenerateToken = <ThrowOnError extends boolean = true>(
  options?: Options<MeRegenerateTokenData, ThrowOnError>,
) =>
  (options?.client ?? client).post<MeRegenerateTokenResponses, MeRegenerateTokenErrors, ThrowOnError>({
    url: "/api/v1/me/token",
    ...options,
  });

/**
 * Delete an organization
 *
 * Deletes the specified organization (can be referenced by ID or name)
 */
export const organizationsDeleteOrganization = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDeleteOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    OrganizationsDeleteOrganizationResponses,
    OrganizationsDeleteOrganizationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}", ...options });

/**
 * Get organization details
 *
 * Returns the details of a specific organization (can be referenced by ID or name)
 */
export const organizationsDescribeOrganization = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrganizationsDescribeOrganizationResponses,
    OrganizationsDescribeOrganizationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}", ...options });

/**
 * Update an organization
 *
 * Updates the specified organization (can be referenced by ID or name)
 */
export const organizationsUpdateOrganization = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateOrganizationData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsUpdateOrganizationResponses,
    OrganizationsUpdateOrganizationErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List integrations in an organization
 *
 * Returns a list of integrations in an organization
 */
export const organizationsListIntegrations = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListIntegrationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrganizationsListIntegrationsResponses,
    OrganizationsListIntegrationsErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations", ...options });

/**
 * Create organization integration
 *
 * Create an organization integration
 */
export const organizationsCreateIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsCreateIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    OrganizationsCreateIntegrationResponses,
    OrganizationsCreateIntegrationErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete organization integration
 *
 * Deletes an integration from an organization
 */
export const organizationsDeleteIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDeleteIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    OrganizationsDeleteIntegrationResponses,
    OrganizationsDeleteIntegrationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations/{integrationId}", ...options });

/**
 * Describe an integration in an organization
 *
 * Returns details of a specific integration in an organization
 */
export const organizationsDescribeIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrganizationsDescribeIntegrationResponses,
    OrganizationsDescribeIntegrationErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations/{integrationId}", ...options });

/**
 * Update integration
 *
 * Updates the configuration for an organization integration
 */
export const organizationsUpdateIntegration = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsUpdateIntegrationResponses,
    OrganizationsUpdateIntegrationErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update integration capabilities
 *
 * Update integration capabilities
 */
export const organizationsUpdateIntegrationCapabilities = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationCapabilitiesData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    OrganizationsUpdateIntegrationCapabilitiesResponses,
    OrganizationsUpdateIntegrationCapabilitiesErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/capabilities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit an integration setup step and go to the next
 *
 * Submit an integration setup step and go to the next
 */
export const organizationsNextIntegrationSetupStep = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsNextIntegrationSetupStepData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsNextIntegrationSetupStepResponses,
    OrganizationsNextIntegrationSetupStepErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/next",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revert the current integration setup step and go to the previous
 *
 * Revert the current integration setup step and go to the previous
 */
export const organizationsPreviousIntegrationSetupStep = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsPreviousIntegrationSetupStepData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsPreviousIntegrationSetupStepResponses,
    OrganizationsPreviousIntegrationSetupStepErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/previous",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update integration property
 *
 * Update integration property
 */
export const organizationsUpdateIntegrationProperty = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationPropertyData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    OrganizationsUpdateIntegrationPropertyResponses,
    OrganizationsUpdateIntegrationPropertyErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/properties",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List integration resources
 *
 * Lists resources for an integration
 */
export const organizationsListIntegrationResources = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsListIntegrationResourcesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrganizationsListIntegrationResourcesResponses,
    OrganizationsListIntegrationResourcesErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/integrations/{integrationId}/resources", ...options });

/**
 * Update integration secret
 *
 * Update integration secret
 */
export const organizationsUpdateIntegrationSecret = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateIntegrationSecretData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    OrganizationsUpdateIntegrationSecretResponses,
    OrganizationsUpdateIntegrationSecretErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/integrations/{integrationId}/secrets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get an organization invite link
 *
 * Returns the invite link for an organization
 */
export const organizationsGetInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsGetInviteLinkData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsGetInviteLinkResponses, OrganizationsGetInviteLinkErrors, ThrowOnError>({
    url: "/api/v1/organizations/{id}/invite-link",
    ...options,
  });

/**
 * Update an organization invite link
 *
 * Enables or disables the invite link for an organization
 */
export const organizationsUpdateInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsUpdateInviteLinkData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    OrganizationsUpdateInviteLinkResponses,
    OrganizationsUpdateInviteLinkErrors,
    ThrowOnError
  >({
    url: "/api/v1/organizations/{id}/invite-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset an organization invite link
 *
 * Generates a new invite link token for an organization
 */
export const organizationsResetInviteLink = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsResetInviteLinkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    OrganizationsResetInviteLinkResponses,
    OrganizationsResetInviteLinkErrors,
    ThrowOnError
  >({ url: "/api/v1/organizations/{id}/invite-link/reset", ...options });

/**
 * Describe organization usage
 *
 * Returns usage tracking and limits for an organization
 */
export const organizationsDescribeUsage = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsDescribeUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsDescribeUsageResponses, OrganizationsDescribeUsageErrors, ThrowOnError>({
    url: "/api/v1/organizations/{id}/usage",
    ...options,
  });

/**
 * Remove a user from an organization
 *
 * Removes a user from an organization (can be referenced by ID or name)
 */
export const organizationsRemoveUser = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsRemoveUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<OrganizationsRemoveUserResponses, OrganizationsRemoveUserErrors, ThrowOnError>({
    url: "/api/v1/organizations/{id}/users/{userId}",
    ...options,
  });

/**
 * List roles
 *
 * Returns available roles for a specific domain type with their permissions and inheritance
 */
export const rolesListRoles = <ThrowOnError extends boolean = true>(
  options?: Options<RolesListRolesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<RolesListRolesResponses, RolesListRolesErrors, ThrowOnError>({
    url: "/api/v1/roles",
    ...options,
  });

/**
 * Create role
 *
 * Creates a new custom role with specified permissions
 */
export const rolesCreateRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesCreateRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<RolesCreateRoleResponses, RolesCreateRoleErrors, ThrowOnError>({
    url: "/api/v1/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete role
 *
 * Deletes an existing custom role
 */
export const rolesDeleteRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesDeleteRoleData, ThrowOnError>,
) =>
  (options.client ?? client).delete<RolesDeleteRoleResponses, RolesDeleteRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}",
    ...options,
  });

/**
 * Describe role
 *
 * Returns detailed information about a specific role including permissions and inheritance
 */
export const rolesDescribeRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesDescribeRoleData, ThrowOnError>,
) =>
  (options.client ?? client).get<RolesDescribeRoleResponses, RolesDescribeRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}",
    ...options,
  });

/**
 * Update role
 *
 * Updates an existing custom role with new permissions
 */
export const rolesUpdateRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesUpdateRoleData, ThrowOnError>,
) =>
  (options.client ?? client).put<RolesUpdateRoleResponses, RolesUpdateRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Assign role
 *
 * Assigns a role to a user within a domain
 */
export const rolesAssignRole = <ThrowOnError extends boolean = true>(
  options: Options<RolesAssignRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<RolesAssignRoleResponses, RolesAssignRoleErrors, ThrowOnError>({
    url: "/api/v1/roles/{roleName}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List secrets
 *
 * Returns the list of secrets
 */
export const secretsListSecrets = <ThrowOnError extends boolean = true>(
  options?: Options<SecretsListSecretsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SecretsListSecretsResponses, SecretsListSecretsErrors, ThrowOnError>({
    url: "/api/v1/secrets",
    ...options,
  });

/**
 * Create a new secret
 *
 * Creates a new secret
 */
export const secretsCreateSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsCreateSecretData, ThrowOnError>,
) =>
  (options.client ?? client).post<SecretsCreateSecretResponses, SecretsCreateSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Deletes a secret
 *
 * Deletes the specified secret
 */
export const secretsDeleteSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsDeleteSecretData, ThrowOnError>,
) =>
  (options.client ?? client).delete<SecretsDeleteSecretResponses, SecretsDeleteSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}",
    ...options,
  });

/**
 * Get secret details
 *
 * Returns the details of a specific secret
 */
export const secretsDescribeSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsDescribeSecretData, ThrowOnError>,
) =>
  (options.client ?? client).get<SecretsDescribeSecretResponses, SecretsDescribeSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}",
    ...options,
  });

/**
 * Updates a secret
 *
 * Updates the specified secret
 */
export const secretsUpdateSecret = <ThrowOnError extends boolean = true>(
  options: Options<SecretsUpdateSecretData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SecretsUpdateSecretResponses, SecretsUpdateSecretErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a key from a secret
 *
 * Removes one key from the secret. Secret must have at least one key remaining.
 */
export const secretsDeleteSecretKey = <ThrowOnError extends boolean = true>(
  options: Options<SecretsDeleteSecretKeyData, ThrowOnError>,
) =>
  (options.client ?? client).delete<SecretsDeleteSecretKeyResponses, SecretsDeleteSecretKeyErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}/keys/{keyName}",
    ...options,
  });

/**
 * Set or overwrite a single key in a secret
 *
 * Sets the value for one key. Creates the key if missing, overwrites if present.
 */
export const secretsSetSecretKey = <ThrowOnError extends boolean = true>(
  options: Options<SecretsSetSecretKeyData, ThrowOnError>,
) =>
  (options.client ?? client).put<SecretsSetSecretKeyResponses, SecretsSetSecretKeyErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}/keys/{keyName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update secret name
 *
 * Updates only the name of the secret. Name must be unique within the domain.
 */
export const secretsUpdateSecretName = <ThrowOnError extends boolean = true>(
  options: Options<SecretsUpdateSecretNameData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SecretsUpdateSecretNameResponses, SecretsUpdateSecretNameErrors, ThrowOnError>({
    url: "/api/v1/secrets/{idOrName}/name",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List service accounts
 *
 * Returns all service accounts in the organization
 */
export const serviceAccountsListServiceAccounts = <ThrowOnError extends boolean = true>(
  options?: Options<ServiceAccountsListServiceAccountsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ServiceAccountsListServiceAccountsResponses,
    ServiceAccountsListServiceAccountsErrors,
    ThrowOnError
  >({ url: "/api/v1/service-accounts", ...options });

/**
 * Create a service account
 *
 * Creates a new service account in the organization
 */
export const serviceAccountsCreateServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<ServiceAccountsCreateServiceAccountData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ServiceAccountsCreateServiceAccountResponses,
    ServiceAccountsCreateServiceAccountErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a service account
 *
 * Deletes a service account and removes its RBAC policies
 */
export const serviceAccountsDeleteServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<ServiceAccountsDeleteServiceAccountData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ServiceAccountsDeleteServiceAccountResponses,
    ServiceAccountsDeleteServiceAccountErrors,
    ThrowOnError
  >({ url: "/api/v1/service-accounts/{id}", ...options });

/**
 * Describe a service account
 *
 * Returns details of a specific service account
 */
export const serviceAccountsDescribeServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<ServiceAccountsDescribeServiceAccountData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ServiceAccountsDescribeServiceAccountResponses,
    ServiceAccountsDescribeServiceAccountErrors,
    ThrowOnError
  >({ url: "/api/v1/service-accounts/{id}", ...options });

/**
 * Update a service account
 *
 * Updates the name or description of a service account
 */
export const serviceAccountsUpdateServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<ServiceAccountsUpdateServiceAccountData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ServiceAccountsUpdateServiceAccountResponses,
    ServiceAccountsUpdateServiceAccountErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-accounts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Regenerate service account token
 *
 * Regenerates the API token for a service account
 */
export const serviceAccountsRegenerateServiceAccountToken = <ThrowOnError extends boolean = true>(
  options: Options<ServiceAccountsRegenerateServiceAccountTokenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ServiceAccountsRegenerateServiceAccountTokenResponses,
    ServiceAccountsRegenerateServiceAccountTokenErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-accounts/{id}/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List triggers
 *
 * Returns a list of all available triggers
 */
export const triggersListTriggers = <ThrowOnError extends boolean = true>(
  options?: Options<TriggersListTriggersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<TriggersListTriggersResponses, TriggersListTriggersErrors, ThrowOnError>({
    url: "/api/v1/triggers",
    ...options,
  });

/**
 * Describe trigger
 *
 * Returns a trigger by its name
 */
export const triggersDescribeTrigger = <ThrowOnError extends boolean = true>(
  options: Options<TriggersDescribeTriggerData, ThrowOnError>,
) =>
  (options.client ?? client).get<TriggersDescribeTriggerResponses, TriggersDescribeTriggerErrors, ThrowOnError>({
    url: "/api/v1/triggers/{name}",
    ...options,
  });

/**
 * List users
 *
 * Returns all users that have roles within a domain
 */
export const usersListUsers = <ThrowOnError extends boolean = true>(
  options?: Options<UsersListUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UsersListUsersResponses, UsersListUsersErrors, ThrowOnError>({
    url: "/api/v1/users",
    ...options,
  });

/**
 * List widgets
 *
 * Returns a list of all available widgets
 */
export const widgetsListWidgets = <ThrowOnError extends boolean = true>(
  options?: Options<WidgetsListWidgetsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<WidgetsListWidgetsResponses, WidgetsListWidgetsErrors, ThrowOnError>({
    url: "/api/v1/widgets",
    ...options,
  });

/**
 * Describe widget
 *
 * Returns a widget by its name
 */
export const widgetsDescribeWidget = <ThrowOnError extends boolean = true>(
  options: Options<WidgetsDescribeWidgetData, ThrowOnError>,
) =>
  (options.client ?? client).get<WidgetsDescribeWidgetResponses, WidgetsDescribeWidgetErrors, ThrowOnError>({
    url: "/api/v1/widgets/{name}",
    ...options,
  });
